export default __webpack_public_path__ + "static/media/avataaars(2).14b93d23.png";